import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=0721d16f&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=0721d16f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0721d16f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0721d16f')) {
      api.createRecord('0721d16f', component.options)
    } else {
      api.reload('0721d16f', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=0721d16f&scoped=true&", function () {
      api.rerender('0721d16f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bCKjbZwQ5SMt/JS/comp/GuestBox.vue"
export default component.exports